module.exports = __webpack_public_path__ + "static/media/completeImg.c641ec48.webp";